import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'app-clm-err-row-expand',
    templateUrl: './clm-err-row-expand.component.html',
    styleUrls: ['./clm-err-row-expand.component.css'],
    standalone: false
})
export class ClmErrRowExpandComponent implements OnInit {
  private static readonly ERROR_CODE_CATEGORY_OVERRIDES = {
    '02112': {
      I: 'Claim Header',
      P: 'Claim Service'
    },
    'PYRTYPCD01': {
      I: 'Subscriber',
      P: 'Subscriber'
    },
    'PYRTYPCD02': {
      I: 'Subscriber',
      P: 'Subscriber'
    }
  };
  // public selectedRow:any;

  @Input() selectedRow;
  routeParam:Params

  constructor( private readonly route: ActivatedRoute) { }

  ngOnInit() {
    this.routeParam = this.route.snapshot.params;
  }

  getEffectiveErrCategory(): string {
    const errorCode = String(
      this.selectedRow?.errCode
      || this.selectedRow?.err_code
      || this.selectedRow?.errorCode
      || this.selectedRow?.error_code
      || this.selectedRow?.code
      || ''
    ).trim().toUpperCase();
    const claimType = String(this.selectedRow?.clmType || '').trim().toUpperCase();
    const override = ClmErrRowExpandComponent.ERROR_CODE_CATEGORY_OVERRIDES[errorCode];

    if (override && override[claimType]) {
      return override[claimType];
    }

    return this.selectedRow?.errCategory;
  }

}
